module.exports = __webpack_public_path__ + "img/purchase1.36b086d3.jpg";